module.exports = __webpack_public_path__ + "static/media/3.4 Bellevois Details Wolke_klein.cea30cb5.jpg";